export const enUS = {
  'errors.apiKeyEmpty': 'apiKey cannot be empty',
  'errors.baseUrlEmpty': 'baseUrl is required — pass XMAX_OPEN_API_PRODUCTION_BASE_URL for production',
  'errors.modelEmpty': 'model cannot be empty',
  'errors.invalidJson': 'Response is not valid JSON',
  'errors.invalidPayload': 'Response payload is invalid',
  'errors.requestFailed': 'Request failed',
  'errors.requestRetry': 'Request failed. Please try again later.',
  'errors.networkError': 'There seems to be a network issue. Please try again later.',
  'errors.requestTimeout': 'Request timeout',
  'errors.invalidFile': 'Upload failed. Please select the file again and try again.',
  'errors.invalidFileType': 'Upload failed. This file type is not supported.',
  'errors.sessionJoinInfoIncomplete': 'session does not contain complete RTC join info',
  'errors.sessionUidMissing': 'session does not contain sessionUid',
  'errors.refImageMissing': 'missing reference image',
  'errors.imageCheckMissingUrl': 'image check response missing url',
  'errors.imageCheckUnsafe': 'image did not pass safety check',
  'errors.captureStreamUnsupported': 'captureStream is not supported in this browser',
  'errors.videoTrackMissing': 'failed to create video track from file',
  'errors.imageTrackMissing': 'failed to create video track from image file',
  'errors.imageLoadFailed': 'failed to load image — try again after selecting the file',
  'errors.invalidMediaFileType': 'unsupported media file type: {type}',
  'errors.videoPlaybackFailed': 'failed to start video playback — try again after selecting the file',
  'errors.rtcNotJoined': 'Please join the RTC room first',
  'errors.rtcNotJoinedForMessaging': 'Please join the RTC room before sending events',
  'errors.systemOverloaded': 'Network connection failed. Please try again.',
  'errors.rtcStreamInterrupted': 'Realtime media transmission was interrupted. Please reconnect.',
  'errors.offlinePositiveNumber': '{label} must be greater than 0',
  'errors.offlineTaskUidEmpty': 'taskUid cannot be empty',
  'errors.offlineUploadedUrlRequired': '{label} must be a URL returned by an Xmax upload method',
  'errors.offlineQualityInvalid': 'quality must be either sd or hd',
  'errors.offlineFpsUnsupported': 'fps is not supported by the Offline Task API',
  'errors.offlinePromptInvalid': 'context.prompt must contain between 1 and 1024 characters',
  'errors.offlineTaskUidsInvalid': 'taskUids must contain between 1 and 100 IDs',
  'errors.offlinePageNumberInvalid': 'pageNumber must be a positive integer',
  'errors.offlinePageSizeInvalid': 'pageSize must be an integer between 1 and 100',
  'errors.offlineStatusInvalid': 'status is not supported by the Offline Task API',
  'errors.offlineTaskTimeout': 'Offline task did not finish within {timeoutMs}ms',

  'notices.lowInputResolution': 'The current input video resolution is too low. Try again with a high-resolution video source.',
  'notices.lowInputImageResolution': 'The current input image resolution is too low. Try again with a high-resolution image.',

  'rtc.alreadyInRoom': 'RTC is already in the target room. Skip duplicate join.',
  'rtc.joiningRoom': 'Joining RTC room',
  'rtc.joinSuccess': 'RTC joinRoom succeeded',
  'rtc.roomUsers': 'Current room users: {users}',
  'rtc.localVideoAlreadyPublished': 'Local video is already published',
  'rtc.localVideoPublished': 'Local video capture started and stream published',
  'rtc.externalVideoPublished': 'External video stream published',
  'rtc.localVideoStopped': 'Local video publishing stopped',
  'rtc.leaveRoomError': 'Error occurred during RTC leaveRoom',
  'rtc.engineDestroyed': 'RTC engine destroyed',
  'rtc.roomEventSent': 'RTC event sent',
  'rtc.remotePlayerRefreshed': 'Remote video player refreshed: {userId}',
  'rtc.remotePlayerRefreshFailed': 'Failed to refresh remote video player',
  'rtc.userJoined': 'User joined RTC room: {userId}',
  'rtc.userLeft': 'User left RTC room: {userId}',
  'rtc.connectionStateChanged': 'RTC connection state changed',
  'rtc.userPublished': 'User published stream: {userId}',
  'rtc.userUnpublished': 'User unpublished stream: {userId}',
  'rtc.seiReceived': 'Remote SEI received: {userId}',
  'rtc.error': 'RTC error: {code}',
  'rtc.captureSizeSet': 'Local video capture size set: {width} x {height}',
  'rtc.encoderPreferenceSet': 'Video encoder preference set to H.264',
  'rtc.encoderPreferenceFailed': 'Failed to set video encoder preference',
  'rtc.remoteWaitSei': 'Remote video is waiting for SEI gate: {userId}',
  'rtc.remoteContainerNotReady': 'Remote video container is not ready. Skip binding.',
  'rtc.remotePlayerBound': 'Remote video player bound: {userId}',
  'rtc.remoteOutputStalled': 'Remote output stalled for more than 20 seconds',
  'rtc.sendSeiFailed': 'Failed to send SEI. The browser or encoder config may not support it.',
  'rtc.seiUnsupported': 'H.264 is not supported. SEI gate will be disabled and output will not be blocked.',
  'rtc.seiGateFallback': 'SEI gate timed out — showing remote output',
  'rtc.getCodecsFailed': 'Failed to get supported codecs. SEI gate will be disabled and output will not be blocked.',
} as const
